import React from 'react';
import './SecondaryButtonEvent.scss';

export const SecondaryButtonEvent = ({label}) =>
    <button className='leave_us_a_message_button'>
        {label}
    </button>
